import { useEffect, useRef } from 'react'

import { ddLogger } from '@b-stock/fe-core/bstock-react'

import { BaseListingCard2025 } from './BaseListingCard2025'
import type { BaseListingCardProps } from './types'

const BaseListingCard = (props: BaseListingCardProps) => {
  const hasLogged = useRef(false)
  const { listing } = props
  const showCard =
    !!listing.title &&
    !!listing.auctionUrl &&
    !!listing.listingId &&
    !!listing.endTime

  useEffect(() => {
    if (!hasLogged.current && !showCard) {
      ddLogger.warn(
        'Home Portal ListingCard Listing data missing either title, auctionUrl, listingId, or endTime'
      )
      hasLogged.current = true
    }
  }, [showCard])

  if (!showCard) {
    return null
  }

  return <BaseListingCard2025 {...props} />
}

export default BaseListingCard
